import { Component, OnInit } from '@angular/core';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { AreaCentralRelacionamento } from '../enumaration/area-central-relacionamento';

declare var $ :any;

@Component({
  selector: 'app-central-atendimento',
  templateUrl: './central-atendimento.component.html',
  styleUrls: ['./central-atendimento.component.css']
})
export class CentralAtendimentoComponent extends AbstractComponent implements OnInit {

  areaEsquerda: string;
  areaDireita: string;

  constructor(private sessaoService: SessaoService) {
    super(sessaoService);
  }

  ngOnInit() {
    // Menu
    $(".btsMenu .btn").removeClass("active activeDrop");
    $(".centrais").addClass("active");

    //Scroll top
    window.scrollTo(0,0);

    // Carrega as áreas da central de relacionamento
    this.areaEsquerda = this.sessaoService.sessao.configuracaoVisual.listaCentralRelacionamento
      .filter(w=>w.area.toString() == AreaCentralRelacionamento[AreaCentralRelacionamento.AREA_ESQUERDA])
      .sort((w1,w2): number => {
        if(w1.nuLinha < w2.nuLinha) return -1;
        if(w1.nuLinha > w2.nuLinha) return 1;
        return 0;
      })
      .map(w=>w.dsCentralRelacionamento)
      .join("");

    this.areaDireita = this.sessaoService.sessao.configuracaoVisual.listaCentralRelacionamento
      .filter(w=>w.area.toString() == AreaCentralRelacionamento[AreaCentralRelacionamento.AREA_DIREITA])
      .sort((w1,w2): number => {
        if(w1.nuLinha < w2.nuLinha) return -1;
        if(w1.nuLinha > w2.nuLinha) return 1;
        return 0;
      })
      .map(w=>w.dsCentralRelacionamento)
      .join("");

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function() {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/central-atendimento/central-atendimento.component.ts